import { render } from "./CasesPanel.vue?vue&type=template&id=9984207c"
import script from "./CasesPanel.vue?vue&type=script&lang=js"
export * from "./CasesPanel.vue?vue&type=script&lang=js"
script.render = render

export default script